export enum AttentionState {
  BANK_SYNC_IN_PROGRESS = 'BANK_SYNC_IN_PROGRESS',
  CATEGORIZATION_IN_PROGRESS = 'CATEGORIZATION_IN_PROGRESS',
  INSTITUTION_UNSUPPORTED = 'INSTITUTION_UNSUPPORTED',
  BANK_SYNC_ERROR_RETRYABLE = 'BANK_SYNC_ERROR_RETRYABLE',
  BANK_REAUTH_REQUIRED = 'BANK_REAUTH_REQUIRED',
}

/** Backend followup request data for bookkeeper-initiated user followups */
export interface FollowupRequest {
  isActive: boolean
  title: string
  description: string
  affectedItems: string[]
}

export interface CubkStatusResponse {
  attentionStates: AttentionState[]
  transactionsSyncedCount: number
  totalTransactions: number
  categorizedCount: number
  categorizedPercentage: number
  incomeCategorized: number
  expensesCategorized: number
  taxDeductionsFound: number
  /** Backend pipeline phase for catch-up bookkeeping */
  phase?: 'complete' | 'your_review' | 'bk_review' | 'bank_incompatible'
  /** Backend followup request data for bookkeeper-initiated user followups */
  followupRequest?: FollowupRequest
}

export enum CubkCardState {
  SYNC_AND_CATEGORIZATION = 'SYNC_AND_CATEGORIZATION', // was BANK_IMPORT + AUTO_CATEGORIZATION
  PREPARE_FOR_BOOKKEEPING = 'PREPARE_FOR_BOOKKEEPING', // new — active while user has incomplete bookkeeping items
  BK_TEAM_REVIEW = 'BK_TEAM_REVIEW',
  // Phase has returned to bk_review after the user finished a followup round.
  // Step 4 (Your review) should render Complete; step 3 is back in Review.
  BK_TEAM_REVIEW_AFTER_FOLLOWUP = 'BK_TEAM_REVIEW_AFTER_FOLLOWUP',
  YOUR_REVIEW = 'YOUR_REVIEW',
  COMPLETE = 'COMPLETE',
  BANK_INCOMPATIBLE = 'BANK_INCOMPATIBLE',
  // Banking-application gate states. Rendered by CubkCardBanking via early-return
  // in CubkCard; never reach the existing CubkCardCollapsed/Expanded path.
  BANKING_AWAITING_APPLICATION = 'BANKING_AWAITING_APPLICATION',
  BANKING_APPROVED_NO_ACCOUNTS = 'BANKING_APPROVED_NO_ACCOUNTS',
  BANKING_NO_ACCOUNTS_FALLBACK = 'BANKING_NO_ACCOUNTS_FALLBACK',
}
